import { AiseaApiFactory } from "@/api/aisea/apiFactory";
import {HtmlUtil} from "@/utils/secure-dataflow";
const ecoShipSeaRoutes = AiseaApiFactory.get("ecoShipSeaRoutes");
const voyageHistoryPoint = AiseaApiFactory.get("enterpriseVoyageHistoryPoint");


export default {
  async fetchSeaRoute({ commit }, payload) {
    let res = await ecoShipSeaRoutes.getSeaRoutes(payload.vesselId, {
      request_id: payload.requestId
    });
    if (res.status) {
      let seaRoutes = JSON.parse(res.data.data.data);
      let seaRoutesPoints = seaRoutes.points.map(v => {
        let props = JSON.parse(v.properties);
        v["properties"] = props;
        return v;
      });
      commit("SET_SEA_ROUTES", seaRoutesPoints);
    } else {
      commit("SET_SEA_ROUTES", []);
    }
  },
  async fetchSeaRouteDetail({ commit }, payload) {
    let res = await ecoShipSeaRoutes.getSeaRouteDetail(payload.vesselId, payload.voyageHistoryId, {
      request_id: payload.requestId
    });
    if (res.status) {
      let seaRoutes = res.data.data.map(element => {
        let convertedSeaRoutes = HtmlUtil.htmlEscape(element.data)
        convertedSeaRoutes = JSON.parse(convertedSeaRoutes)
        let seaRoutesPoints = convertedSeaRoutes.points.map(v => {
          let props = JSON.parse(v.properties);
          v["properties"] = props;
          return v;
        });
        return seaRoutesPoints
      })
      commit("SET_SEA_ROUTES", seaRoutes);
    } else {
      commit("SET_SEA_ROUTES", []);
    }
  },
  async fetchVoyageHistoryDetail(_, payload) {
    let res = await voyageHistoryPoint.fetch(payload.vesselId, payload.params);
    return res.data
  },
  async setSeaRouteDetailCondition({ commit }, payload) {
    commit("SET_SEA_ROUTE_DETAIL_CONDITION", payload)
  },
  async getVesselPositions(_, params) {
    return AiseaApiFactory.get("enterpriseVoyageHistoryPoint")
      .fetch(params.vessel_id, params.range)
      .then(res => {
        return res.data.points
      });
  },
  async getVoyageFuelEconomy(id) {
    return AiseaApiFactory.get("enterpriseVoyageHistoryPoint")
      .fetchFuelEconomy(id)
      .then(res => {
        return res.data
      });
  },
  async getVoyageFuelEconomyArray(_, ids) {
    let promiseAll = []
    promiseAll = ids.map(async (id) => { 
      return AiseaApiFactory.get("enterpriseVoyageHistoryPoint")
      .fetchFuelEconomy(id)
      .then(res => {
        return {...res.data, id: id}
      });
    });
    return Promise.all(promiseAll);
  },
  async getVesselReportList(_, payload) {
    return AiseaApiFactory.get("vesselReport")
      .fetchList(payload)
      .then(res => {
        return res.data
      });
  },
}